import React from 'react';
import { processSteps } from '../data/mock';
import { Lightbulb, FileSpreadsheet, Search, ClipboardCheck } from 'lucide-react';

const stepIcons = {
  'Concept': Lightbulb,
  'Design & Tech Pack': FileSpreadsheet,
  'Vendor Sourcing': Search,
  'Quality Control Oversight': ClipboardCheck,
};

const ProcessSection = () => {
  return (
    <section className="py-20 lg:py-24 bg-[#F5F1EC]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        {/* Section Header */}
        <div className="text-center mb-16">
          <span className="font-inter text-xs tracking-[0.3em] uppercase text-[#8B7355]">
            How I Work
          </span>
          <h2 className="font-playfair text-3xl md:text-4xl lg:text-5xl font-light text-[#3D3D3D] mt-4">
            The Process
          </h2>
          <div className="w-12 h-[1px] bg-[#8B7355] mx-auto mt-6" />
        </div>

        {/* Process Timeline */}
        <div className="relative">
          {/* Connection Line */}
          <div className="hidden lg:block absolute top-1/2 left-0 right-0 h-[1px] bg-[#C4B5A4] -translate-y-1/2" />

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            {processSteps.map((step, index) => {
              const IconComponent = stepIcons[step.title] || Lightbulb;
              return (
                <div
                  key={step.id}
                  className="relative group"
                >
                  {/* Step Card */}
                  <div className="bg-white p-6 lg:p-8 text-center relative z-10 hover:shadow-lg transition-shadow duration-500">
                    {/* Step Number */}
                    <div className="w-12 h-12 mx-auto mb-4 flex items-center justify-center bg-[#8B7355] text-[#FAF8F5] font-playfair text-lg group-hover:bg-[#3D3D3D] transition-colors duration-300">
                      {String(step.id).padStart(2, '0')}
                    </div>

                    {/* Icon */}
                    <div className="w-10 h-10 mx-auto mb-4 flex items-center justify-center text-[#8B7355]">
                      <IconComponent size={28} strokeWidth={1.5} />
                    </div>

                    {/* Title */}
                    <h3 className="font-playfair text-lg text-[#3D3D3D] mb-3">
                      {step.title}
                    </h3>

                    {/* Description */}
                    <p className="font-inter text-xs text-[#5A5A5A] leading-relaxed">
                      {step.description}
                    </p>
                  </div>

                  {/* Arrow connector for mobile/tablet */}
                  {index < processSteps.length - 1 && (
                    <div className="lg:hidden flex justify-center py-4">
                      <div className="w-[1px] h-8 bg-[#C4B5A4]" />
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ProcessSection;
